import type { Invitation as GraftInvitation } from '@graft/nuget-gc.webportals.memberships'

import type { Invitation } from '../types/invitation.type'

function mapInvitationTypeToFlags(invitationType: string): Pick<Invitation, 'asWorkspaceAdmin' | 'asProjectAdmin'> {
  const normalized = invitationType.toLowerCase()

  return {
    asWorkspaceAdmin: normalized.includes('workspace'),
    asProjectAdmin: normalized.includes('project'),
  }
}

export async function invitationToObject(entity: GraftInvitation): Promise<Invitation> {
  const [
    invitationId,
    workspaceId,
    projectId,
    workspaceName,
    projectName,
    invitingUserId,
    invitationDate,
    invitationType,
  ] = await Promise.all([
    entity.get_invitationId(),
    entity.get_workspaceId(),
    entity.get_projectId(),
    entity.get_workspaceName(),
    entity.get_projectName(),
    entity.get_invitingUserId(),
    entity.get_invitationDate(),
    entity.get_invitationType(),
  ])

  return {
    invitationId,
    workspaceId,
    projectId,
    workspaceName,
    projectName,
    invitingPerson: invitingUserId,
    invitationDate: invitationDate ? new Date(invitationDate).toISOString() : undefined,
    ...mapInvitationTypeToFlags(invitationType),
  }
}
